import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import {
  Button,
  Popover,
  Intent,
  Tooltip,
  Tag,
  Menu,
  MenuItem
} from "@blueprintjs/core";
import React from "react";
import { map, startCase } from "lodash-es";
import { pureNoFunc, wrapDialog } from "@teselagen/ui";
import { compose } from "redux";
import { showDialog } from "../GlobalDialogUtils";
export default pureNoFunc(function AlignmentVisibilityTool(props) {
  return /* @__PURE__ */ jsx(
    Popover,
    {
      minimal: true,
      position: "bottom",
      content: /* @__PURE__ */ jsx(VisibilityOptions, { ...props }),
      target: /* @__PURE__ */ jsx(Tooltip, { content: "Visibility Options", children: /* @__PURE__ */ jsx(
        Button,
        {
          className: "tg-alignment-visibility-toggle",
          small: true,
          rightIcon: "caret-down",
          intent: Intent.PRIMARY,
          minimal: true,
          icon: "eye-open"
        }
      ) })
    }
  );
});
function VisibilityOptions({
  // alignmentAnnotationVisibility = {},
  alignmentAnnotationVisibilityToggle,
  togglableAlignmentAnnotationSettings = {},
  // alignmentAnnotationLabelVisibility = {},
  // alignmentAnnotationLabelVisibilityToggle
  annotationsWithCounts,
  currentPairwiseAlignmentIndex
}) {
  let annotationCountToUse = {};
  if (currentPairwiseAlignmentIndex) {
    annotationCountToUse = annotationsWithCounts[currentPairwiseAlignmentIndex];
  } else {
    annotationCountToUse = annotationsWithCounts[0];
  }
  const subMenuElements = ["physicalProperties", "plot"];
  const physicalPropertyElements = [
    "hydrophobicity",
    "polar",
    "negative",
    "positive",
    "charged",
    "aliphatic",
    "aromatic"
  ];
  const plotElements = ["conservation", "properties"];
  return /* @__PURE__ */ jsx(
    Menu,
    {
      style: { padding: 10 },
      className: "alignmentAnnotationVisibilityToolInner",
      children: map(togglableAlignmentAnnotationSettings, (visible, annotationName) => {
        if (!physicalPropertyElements.includes(annotationName) && !plotElements.includes(annotationName)) {
          return /* @__PURE__ */ jsx(
            MenuItem,
            {
              icon: visible && !subMenuElements.includes(annotationName) ? "tick" : "",
              onClick: (e) => {
                e.stopPropagation();
                if (annotationName === "axis") {
                  return alignmentAnnotationVisibilityToggle({
                    axisNumbers: !visible,
                    axis: !visible
                  });
                }
                if (annotationName === "cdsFeatureTranslations" && !visible) {
                  return alignmentAnnotationVisibilityToggle({
                    cdsFeatureTranslations: !visible,
                    translations: !visible
                  });
                }
                alignmentAnnotationVisibilityToggle({
                  [annotationName]: !visible
                });
              },
              text: /* @__PURE__ */ jsxs(Fragment, { children: [
                startCase(annotationName).replace("Cds", "CDS").replace("Dna", "DNA"),
                annotationName in annotationCountToUse ? /* @__PURE__ */ jsx(Tag, { round: true, style: { marginLeft: 7 }, children: annotationCountToUse[annotationName] }) : ""
              ] }),
              children: annotationName === "physicalProperties" ? map(
                togglableAlignmentAnnotationSettings,
                (_visible, _annotationName) => {
                  if (physicalPropertyElements.includes(_annotationName)) {
                    return /* @__PURE__ */ jsx(
                      MenuItem,
                      {
                        icon: _visible ? "tick" : "",
                        onClick: (e) => {
                          e.stopPropagation();
                          alignmentAnnotationVisibilityToggle({
                            [_annotationName]: !_visible
                          });
                        },
                        text: /* @__PURE__ */ jsx(Fragment, { children: startCase(_annotationName) })
                      },
                      _annotationName
                    );
                  }
                }
              ).filter(Boolean) : annotationName === "plot" ? map(
                togglableAlignmentAnnotationSettings,
                (_visible, _annotationName) => {
                  if (plotElements.includes(_annotationName)) {
                    return /* @__PURE__ */ jsxs("div", { style: { position: "relative" }, children: [
                      /* @__PURE__ */ jsx(
                        MenuItem,
                        {
                          className: `plot-${_annotationName}`,
                          icon: _visible ? "tick" : "",
                          onClick: (e) => {
                            e.stopPropagation();
                            alignmentAnnotationVisibilityToggle({
                              [_annotationName]: !_visible
                            });
                          },
                          text: /* @__PURE__ */ jsx(Fragment, { children: startCase(_annotationName) })
                        },
                        _annotationName
                      ),
                      _annotationName === "properties" ? /* @__PURE__ */ jsx(
                        Button,
                        {
                          icon: "info-sign",
                          style: {
                            position: "absolute",
                            top: 3,
                            right: 0
                          },
                          onClick: () => {
                            showDialog({
                              ModalComponent: PropertyDialog
                            });
                          },
                          minimal: true,
                          small: true
                        }
                      ) : null
                    ] });
                  }
                }
              ).filter(Boolean) : null
            },
            annotationName
          );
        }
      })
    }
  );
}
const PropertyDialog = compose(
  wrapDialog({
    title: "Amino Acid Properties",
    style: {
      width: 600
    }
  })
)(function() {
  return /* @__PURE__ */ jsx("div", { style: { width: "100%", padding: 10 }, children: /* @__PURE__ */ jsx("img", { src: "/aaprops.svg", width: 580, alt: "Amino Acid Properties" }) });
});
